import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import {
  CURRENCIES,
  DEFAULT_CURRENCY,
  detectCurrencyFromCountry,
  formatPrice,
} from './currencyConfig';

const STORAGE_KEY = 'nexusai-currency';

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(DEFAULT_CURRENCY);

  // Al montar: preferencia guardada > autodetección por país (Cloudflare) > USD
  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && CURRENCIES[saved]) {
      setCurrencyState(saved);
      return;
    }
    let cancelled = false;
    fetch('/api/geo')
      .then((r) => r.json())
      .then((data) => {
        if (cancelled) return;
        setCurrencyState(detectCurrencyFromCountry(data && data.country));
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const setCurrency = useCallback((code) => {
    if (!CURRENCIES[code]) return;
    setCurrencyState(code);
    localStorage.setItem(STORAGE_KEY, code);
  }, []);

  const format = useCallback((usdValue) => formatPrice(usdValue, currency), [currency]);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, format }}>
      {children}
    </CurrencyContext.Provider>
  );
}

// Hook seguro: si se usa fuera del Provider, cae a USD sin romper.
export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) {
    return {
      currency: DEFAULT_CURRENCY,
      setCurrency: () => {},
      format: (usdValue) => formatPrice(usdValue, DEFAULT_CURRENCY),
    };
  }
  return ctx;
}
